﻿'use strict'

var jquery = require('jquery');
global.$ = global.jQuery = jquery;      // To get the jQuery object in the global scope because Bootstrap 4 doesn't do modules properly
require('mmenu-js');

module.exports = (function () {

    // private methods


    // public methods

    /**
    * @ngdoc method
    * @name initializeNavigation
    * @description Setup the navigation for the site.  Event handlers, etc
    **/
    var initializeMobileNavigation = function () {

        //console.log("topNavigation initialized");
        const menu = new Mmenu("#bl-mobileMenu", {
            offCanvas: {
                use: false
            },
            page: {
                selector: "#panel-wrapper"
            },
            navbar: {
                add: true
            },
            "navbars": [],
            
        });

        var $menuElement = $("#bl-mobileMenu");
        var $hamburger = $(".hamburger");

        //// Toggle menu visibility
        //$hamburger.addEventListener("click", () => {
        //    menuElement.classList.toggle("menu-open");
        //});

         var API = menu.API;

        
        $hamburger.on("click", function () {
            if ($(this).hasClass('is-active')) {
                API.closePanel();
                $hamburger.removeClass("is-active");
                $menuElement.removeClass("mm-menu--position-right mm-menu--theme-light mm-menu--opened");
                $("#bl-mobileMenu").css("z-index", 0);
                $("#bl-mobileMenu").css("display", "none");
            } else {
                API.openPanel();
                $hamburger.addClass("is-active");
                $menuElement.addClass("mm-menu--position-right mm-menu--theme-light mm-menu--opened");
                $("#bl-mobileMenu").css("z-index", 100);
                $("#bl-mobileMenu").css("display", "flex");
            }
        });

        API.bind("open:before", function () {
            setTimeout(function () {
                $hamburger.addClass("is-active");
                $hamburger.attr('aria-label', 'close mobile menu');
            }, 100);
        });
        API.bind("close:before", function () {
            setTimeout(function () {
                $hamburger.removeClass("is-active");
                $hamburger.attr('aria-label', 'open mobile menu');
            }, 100);
        });

    };

    // Return an object exposing the public items
    return {
        initialize: initializeMobileNavigation
    };

}());